module.exports = {"TXTCLI_My_News":{"id":"TXTCLI_My_News","defaultMessage":"Saját híreim"}}